import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ICredentialsPathParams, ICreateCredentials, IUpdateCredentials } from '../../shared/models/credentials.model';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  private readonly baseUrl = environment.baseBackendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) { }

  /**
   * Elimina una credencial por ID
   * @param id ID de la credencial a eliminar
   */
  deleteCredential(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/api/Credentials/${id}`).pipe(
      catchError((error) => {
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Actualiza una credencial por ID
   * @param id ID de la credencial a actualizar
   * @param credentialsData Datos de la credencial a actualizar
   */
  updateCredential(id: number, credentialsData: IUpdateCredentials): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/api/Credentials/${id}`, credentialsData).pipe(
      catchError((error) => {
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Crea una nueva credencial
   * @param credentialsData Datos de la nueva credencial
   */
  createCredential(credentialsData: ICreateCredentials): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/Credentials`, credentialsData).pipe(
      catchError((error) => {
        this.errorHandlerService.handleError(error);
        return throwError(() => error);
      })
    );
  }
}
